// @flow
import React from 'react';

import Menu, {MenuItem} from 'sail/Menu';
import Group from 'sail/Group';
import Icon from 'sail/Icon';
import {ButtonLink} from 'sail/Button';
import Box from 'sail/Box';
import FlagIcon, {FLAG_COUNTRY_CODES} from 'sail/FlagIcon';
import {chevronDown} from 'sail/Icon/Assets';

import {LOCATIONS, THEMES} from './constants';
import type {State, Dispatch} from './state';

type Props = {|
  state: State,
  dispatch: Dispatch,
|};

const LocationDropdown = ({state, dispatch}: Props) => {
  const handleClick = (key) => {
    dispatch({kind: 'LOCATION_CHANGED', location: key});
  };

  const items = Object.keys(LOCATIONS).map((key) => (
    <MenuItem
      key={key}
      onClick={() => handleClick(key)}
      style={{minWidth: '100px'}}
    >
      <Group direction="horizontal" spacing={8} alignItems="center">
        <Icon
          icon="check"
          size={12}
          color={state.location === key ? 'selected' : 'white'}
        />
        <FlagIcon countryCode={FLAG_COUNTRY_CODES[key.toUpperCase()]} />
        {LOCATIONS[key].label}
      </Group>
    </MenuItem>
  ));

  return (
    <Box
      style={{
        borderRadius: '30px',
        width: '104px',
      }}
      background={THEMES[state.theme].tabColor || 'white'}
      padding={{horizontal: 16, vertical: 8}}
      margin={8}
      flex={{justifyContent: 'center'}}
    >
      <Menu items={items}>
        <Group direction="horizontal" alignItems="center" spacing={8}>
          <FlagIcon
            countryCode={FLAG_COUNTRY_CODES[state.location.toUpperCase()]}
          />
          <ButtonLink
            label={LOCATIONS[state.location].label}
            icon={chevronDown}
            iconPosition="right"
            color="gray900"
          />
        </Group>
      </Menu>
    </Box>
  );
};

export default LocationDropdown;
